import React from 'react';
import PropTypes from 'prop-types';
import withTranslate from 'components/withTranslate';
import { closeModal, submitPreferencesForm } from '../../../actionCreators';
import { connect } from 'react-redux';

export const UnsubscribeFromAll = ({ _t, onCancel, onConfirm }) => {
  return (
    <div
      className="unsubscribe-from-all-modal-content"
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div id="modal-description" role="region">
        <p>
          {_t(
            'By opting out of all updates, you will no longer receive ballot status notifications for your local election jurisdiction.',
          )}
        </p>
        <p>
          {_t(
            'BallotTrax is committed to respecting your privacy and guarantees that your personal information will never be sold or shared with any third parties.',
          )}
        </p>
      </div>

      <div className="button-layout-modal big-top-margin gigantic-buttons">
        <button
          className={'close-modal-cancel-button'}
          onClick={onCancel}
          aria-label={'Cancel and keep receiving updates'}
        >
          {_t('CANCEL')}
        </button>
        <button
          className={'unsubscribe-from-all-button-modal'}
          onClick={onConfirm}
          aria-label={'Confirm opt out from all ballot status updates'}
          aria-describedby="opt-out-warning"
        >
          {_t('OPT OUT OF ALL UPDATES')}
        </button>
        <div id="opt-out-warning" className="screen-reader">
          {
            'Warning: This action will permanently stop all ballot status notifications'
          }
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => {
    return dispatch(closeModal('unsubscribeFromAll'));
  },
  onConfirm: () => {
    dispatch(
      submitPreferencesForm(
        {
          email_opt_in: false,
          voice_opt_in: false,
          sms_opt_in: false,
          email: '',
          phone_sms: '',
          phone_voice: '',
        },
        true,
      ),
    );
    return dispatch(closeModal('unsubscribeFromAll'));
  },
});
export default withTranslate(
  connect(null, mapDispatchToProps)(UnsubscribeFromAll),
);

UnsubscribeFromAll.propTypes = {
  _t: PropTypes.func.isRequired,
};
